import auth from './_auth.js';
import { combineReducers } from 'redux';
const rootReducer = combineReducers({
  auth
});
export default rootReducer;
